import styled from "styled-components"

export const InsuranceList = styled.ul`
  padding-left: 1em;

  li {
    margin: 1em 0;
  }
`
